import React from "react";
import "./Skills.css"





const Skills = ()=>{
    return(
        <div className="skill" id="skill1">
        <h1 data-aos="zoom-in">SKILLS</h1>
        <div className="fake2"></div>
        <nav className="skillline" data-aos="fade-left">
            <div className="line html">
                <span>HTML</span>
            </div>
            <div className="shaline"></div>
            <div className="unlinehtml"></div>
        </nav>
        <nav className="skillline" data-aos="fade-right">
            <div className="line css">
                <span>CSS</span>
            </div>
            <div className="shaline"></div>
            <div className="unlinecss"></div>
        </nav>
        <nav className="skillline" data-aos="fade-left">
            <div className="line javascript">
                <span>JAVASCRIPT</span>
            </div>
            <div className="shaline"></div>
            <div className="unlinejavascript"></div>
        </nav>
        <nav className="skillline" data-aos="fade-right">
            <div className="line c">
                <span>C</span>
            </div>
            <div className="shaline"></div>
            <div className="unlinec"></div>
        </nav>
        <nav className="skillline" data-aos="fade-left">
            <div className="line java">
                <span>JAVA</span>
            </div>
            <div className="shaline"></div>
            <div className="unlinejava"></div>
        </nav>
        <nav className="skillline" data-aos="fade-right">
            <div className="line python">
                <span>PYTHON</span>
            </div>
            <div className="shaline"></div>
            <div className="unlinepython"></div>
        </nav>
        <nav className="skillline" data-aos="fade-left">
            <div className="line React">
                <span>REACT JS</span>
            </div>
            <div className="shaline"></div>
            <div className="unlinereact"></div>
        </nav>
        <nav className="skillline" data-aos="fade-left">
            <div className="line node">
                <span>Node JS</span>
            </div>
            <div className="shaline"></div>
            <div className="unlinenode"></div>
        </nav>

        </div>
    )
}
export default Skills;